/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteCompositionsDetailMutationResponse, WebAppDeleteCompositionsDetailPathParams, WebAppDeleteCompositionsDetail401, WebAppDeleteCompositionsDetail403, WebAppDeleteCompositionsDetail404 } from "../models/WebAppDeleteCompositionsDetail";

export function getWebAppDeleteCompositionsDetailUrl(id: WebAppDeleteCompositionsDetailPathParams["id"]) {
  const res = { method: 'DELETE', url: `/web-app/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Delete a composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export async function webAppDeleteCompositionsDetail(id: WebAppDeleteCompositionsDetailPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, unknown>({ method : "DELETE", url : getWebAppDeleteCompositionsDetailUrl(id).url.toString(), ... requestConfig })
  return res.data
}